// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniatureQuotedMessage__content-d504c9 {
  display: flex;
  gap: 6px;
}

.MiniatureQuotedMessage__icon-eb0d6c {
  fill: var(--chat-bubble-text-secondary);
  vertical-align: text-bottom;
  flex-shrink: 0;
  margin-top: 1px;
}

.MiniatureQuotedMessage__text-d880e4 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
}

.MiniatureQuotedMessage__text-expanded-a58b49 .MiniatureQuotedMessage__text-d880e4 {
  overflow: visible;
  white-space: pre-wrap;
  word-break: break-word;
}

.MiniatureQuotedMessage__icon-wrapper-a38317 {
  display: inline-flex;
  align-items: baseline;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/components/MiniatureQuotedMessage/MiniatureQuotedMessage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,uCAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,oBAAA;EACA,qBAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  gap: 6px;\n}\n\n.icon {\n  fill: var(--chat-bubble-text-secondary);\n  vertical-align: text-bottom;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-grow: 1;\n}\n\n.text-expanded .text {\n  overflow: visible;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.icon-wrapper {\n  display: inline-flex;\n  align-items: baseline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MiniatureQuotedMessage__content-d504c9`,
	"icon": `MiniatureQuotedMessage__icon-eb0d6c`,
	"text": `MiniatureQuotedMessage__text-d880e4`,
	"text-expanded": `MiniatureQuotedMessage__text-expanded-a58b49`,
	"textExpanded": `MiniatureQuotedMessage__text-expanded-a58b49`,
	"icon-wrapper": `MiniatureQuotedMessage__icon-wrapper-a38317`,
	"iconWrapper": `MiniatureQuotedMessage__icon-wrapper-a38317`
};
module.exports = ___CSS_LOADER_EXPORT___;
